import React from "react";
import { Flex, Typography } from "antd";
import type { BusinessWithServicesDTO } from "api";
import { generatePath, Link } from "react-router-dom";
import Routes from "src/constants/routes";

import BusinessCard from "../BusinessCard";
import BusinessServicesList from "../BusinessServicesList";
import { BusinessListItemContainer, BusinessListItemPreviewContainer } from "./BusinessListItem.styles";

export interface BusinessListItemProps {
  business: BusinessWithServicesDTO;
}

const BusinessListItem: React.FC<BusinessListItemProps> = ({ business }) => {
  const link = generatePath(Routes.business, { id: business.id });

  return (
    <BusinessListItemContainer>
      <BusinessListItemPreviewContainer>
        <Link style={{ display: "contents" }} to={link}>
          <BusinessCard business={business} />
        </Link>
      </BusinessListItemPreviewContainer>

      <Flex flex={1} vertical>
        <Link to={link}>
          <Typography.Title level={4}>{business.name}</Typography.Title>
        </Link>
        <Typography.Text type="secondary">{business.address}</Typography.Text>

        <BusinessServicesList services={business.services || []} />
      </Flex>
    </BusinessListItemContainer>
  );
};

export default BusinessListItem;
